package floris.graphics.backoffice.pages.admin.projects

import floris.graphics.models.domain.models.project.Project
import floris.graphics.repo.ProjectRepo
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ProjectsViewModel(
    private val projectRepo: ProjectRepo = ProjectRepo,
    private val coroutineScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
) {
    private val _state = MutableStateFlow(ProjectsState())
    val state = _state.asStateFlow()

    private val _eventFlow = Channel<ProjectsUiEvent>()
    val eventFlow = _eventFlow.receiveAsFlow()

    fun onEvent(event: ProjectsEvent) = coroutineScope.launch {
        when (event) {
            is ProjectsEvent.LoadProjects -> {
                _state.update { it.copy(isLoading = true) }
                val items = projectRepo.getProjects()
                _state.update { it.copy(projects = items, isLoading = false) }
            }

            is ProjectsEvent.NavigateToManageProject -> _eventFlow.send(ProjectsUiEvent.NavigateToManageProject(event.projectId))
        }
    }

    init {
        onEvent(ProjectsEvent.LoadProjects)
    }
}

data class ProjectsState(
    val projects: List<Project> = emptyList(),
    val isLoading: Boolean = false,
    val errorText: String = ""
)

sealed class ProjectsEvent {
    data object LoadProjects : ProjectsEvent()
    data class NavigateToManageProject(val projectId: String? = null) : ProjectsEvent()
}

sealed class ProjectsUiEvent {
    data class NavigateToManageProject(val projectId: String? = null) : ProjectsUiEvent()
}
